// extracted by mini-css-extract-plugin
module.exports = {"search-input":"search-input___1gikA","search-value":"search-value___1Qugb","close-icon":"close-icon___2HHYy","input-icon":"input-icon___1MQWM"};